
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { GoProject, GoTasklist } from 'react-icons/go'
import { VscWorkspaceTrusted, VscWorkspaceUnknown } from "react-icons/vsc";

import { ITask } from '../../../data_models/task'
import { IProject } from '../../../data_models/project'
import { FiEdit3, FiUsers } from 'react-icons/fi'
import { IFreelancer } from '../../../data_models/freelancer'
import { FilledButton, OutlinedButton } from '../../common/Button';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { IEmployer } from '../../../data_models/employer';
import { useEffect, useState } from 'react';

export const ProjectDetailsMetrics: React.FC<{
    project: IProject,
    tasks: ITask[],
}> = ({ project, tasks }) => {

    const [stats, setStats] = useState<any[]>([]);

    useEffect(() => {
        if (!project) return

        const totalTasks = tasks.length;
        const assignedTasks = tasks.filter((task) => task.currentlyAssignedTo).length;
        const unassignedTasks = totalTasks - assignedTasks;
        const percentageCompleted = `${Number(project.percentageCompleted).toFixed(0)}%`;
        setStats([
            { name: 'Total Tasks', stat: totalTasks },
            { name: 'Assigned Tasks', stat: assignedTasks },
            { name: 'Unassigned Tasks', stat: unassignedTasks },
            { name: 'Percentage Completed', stat: percentageCompleted },
        ])
    }, [project, tasks])


    return (

        <div>
            <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-4">
                {stats.map((item) => (
                    <div key={item.name} className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow-md border border-gray-200  sm:p-6">
                        <dt className="truncate text-sm font-medium text-gray-500">{item.name}</dt>
                        <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{item.stat}</dd>
                    </div>
                ))}
            </dl>
        </div>
    )
}